SCALAR_TYPE_EXTENSION